<template>
  <div class="d-flex justify-space-between align-center mb-2">
    <div class="d-flex align-self-center align-center">
      <v-skeleton-loader width="20" height="20" type="image" />

      <v-skeleton-loader
        width="100"
        height="12"
        type="text"
        class="ma-0 mx-2"
      />
    </div>

    <v-skeleton-loader width="20" height="12" type="text" />
  </div>
</template>

<script>
export default {};
</script>
